import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { injectIntl } from 'react-intl';
import { titleize } from 'lib/string_utils';
import Immutable from 'immutable';
import _ from 'underscore';
import classnames from 'classnames';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { countAdultsIn, addonsWithPrices } from 'lib/pricing_utils';

import FormController from 'lib/form/controller';
import IntegrationActionCreator from 'action_creators/integration';
import BookingRequestActionCreator from 'action_creators/booking_request';
import TourAvailabilityActionCreator from 'action_creators/tour_availability';
import TourAvailabilityService from 'services/tour_availability';
import TourAvailability from 'services/tour_availability';

import ModalActionCreator from 'action_creators/modal';
import PricingActionCreator from 'action_creators/pricing';
import BookingDetailsStore from 'stores/plugins/booking_details';
import D13nStore from 'stores/plugins/d13n';
import Guests from 'views/plugins/booking_request/guests';
import Dates from 'views/plugins/booking_request/dates';
import Times from 'views/plugins/booking_request/times';
import Addons from 'views/plugins/booking_request/addons';
import Error from 'views/plugins/booking_request/error';
import { TimingValidations } from 'views/plugins/booking_request/validations/timing';
import { BaseballHallOfFameMembershipUpsell } from 'views/ui/dynamic/';

import { LocationSelect } from 'ui_system/select/location/LocationSelect';
import { sendEventToSegment } from 'views/anyguide/helpers/analytics/segmentHelpers';

import { JoinWaitlist } from './waitlist/JoinWaitlist';

import NoAvailability from './no_availability';
import SubmitButton from './request_booking';
import PaymentMethods from './payment_methods';

import TimezoneWrapper from '../../../booking_request/timezone_wrapper/TimezoneWrapper';

import { getSessionId } from './Helpers';
import { SegmentTrackingProvider } from './BookingDetailsContext';

import './index.scss';

const dynamic_components = {
  baseball_hall_of_fame_membership_upsell: BaseballHallOfFameMembershipUpsell,
};

let notificationSent = false;
const trackedTours = new Set();

const BookingDetailsInternal = createReactClass({
  displayName: 'TourPage-BookingDetails',

  mixins: [StoreInterestMixin, FormController],

  propTypes: {
    intl: PropTypes.object.isRequired,
    tour_id: PropTypes.number.isRequired,
    available_dates: PropTypes.object.isRequired,
    addon_availability: PropTypes.object.isRequired,
    is_recurrent: PropTypes.bool.isRequired,
    is_single_day: PropTypes.bool.isRequired,
    initial_fields: PropTypes.object.isRequired,
    min_people: PropTypes.number.isRequired,
    max_people: PropTypes.number.isRequired,
    contact_props: PropTypes.object.isRequired,
    date_picker_type: PropTypes.string.isRequired,
    booking_request_id: PropTypes.string,
    addons: PropTypes.array,
    book_in_plugin: PropTypes.bool,
    is_affiliate: PropTypes.bool,
    can_be_paid_in_cash: PropTypes.bool,
    tour_settings: PropTypes.object,
    unit_types: PropTypes.object,
    online: PropTypes.bool,
    tour_timezone: PropTypes.string,
    available_datetimes: PropTypes.array,
    is_ga4_enabled: PropTypes.bool,
    total_without_service_fee: PropTypes.number,
    unit_price_for_initial_pricing: PropTypes.number,
    initial_ticket_quantity: PropTypes.number.isRequired,
    sold_out_link_text: PropTypes.string,
    brand_color: PropTypes.string,
    iso_time: PropTypes.bool,
    has_ticket_capacity_enabled: PropTypes.bool,
    tour_ticket_capacities: PropTypes.array,
    segment_tracking_enabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      booking_request_id: null,
      unit_types: [],
      addons: [],
    };
  },

  getInitialState() {
    const initialState = {
      tourDates: {},
      availableDates: {},
      availableTimes: Immutable.fromJS({}),
      available_datetimes: {},
      availabilityFiltered: false,
      fields: Immutable.Map(this.props.initial_fields),
      errors: Immutable.Map({}),
      loading: false,
      booking_request_id: null,
      showDates: false,
      hidden: this.props.layout === 'tablet',
      asynchronous_calendar: this.props.asynchronous_calendar,
      originUrl: null,
      addonPrices: [],
      unitPrices: {},
      hide_inputs_if_no_choice_required:
        this.tourSetting('graceful_booking_inputs') === 'true',
      location: null,
      total_without_service_fee: 0,
      unit_price_for_initial_pricing: 0,
      has_available_waitlist_slots: false,
      initial_ticket_quantity: this.props.initial_ticket_quantity,
      capacityError: null,
      has_ticket_capacity_enabled: this.props.has_ticket_capacity_enabled,
      slotTicketCapacities: this.props.tour_ticket_capacities,
      capacityErrorJobInProgress: null,
      capacityErrorCleared: false,
    };

    if (!this.props.asynchronous_calendar) {
      // Loading Syncronously when page is loaded
      initialState.tourDates = this.props.available_dates;
    }

    return initialState;
  },

  tourSetting(key) {
    let val = null;
    if (this.props.tour_settings && this.props.tour_settings[key]) {
      val = this.props.tour_settings[key].value;
    }
    return val;
  },

  getStoreInterests() {
    const storeInterests = {
      loading: 'booking_request.loading',
      tourDates: 'tour_availability.dates',
      availableDates: 'tour_availability.availableDates',
      availableTimes: 'tour_availability.availableTimes',
      availabilityFiltered: 'tour_availability.filtered',
      isLoadingAvailableDates: 'tour_availability.isLoading',
      saved: 'booking_request.saved',
      errors: 'booking_request.errors',
      booking_request_id: 'booking_request.booking_request_id',
      showDates: 'booking_details.showDates',
      hidden: 'booking_details.hidden',
      layoutNeeded: 'booking_details.layoutNeeded',
      originUrl: 'booking_details.originUrl',
      addonPrices: 'pricing.addons',
      unitPrices: 'pricing.units',
      cashTotal: 'pricing.cash_total_formatted',
      onlineTotal: 'pricing.online_total_formatted',
      total: 'pricing.total',
      tour_name: 'pricing.tour_name',
      currency: 'pricing.currency',
      total_without_service_fee: 'pricing.total_without_service_fee',
      unit_price_for_initial_pricing: 'pricing.unit_price_for_initial_pricing',
    };

    return storeInterests;
  },

  componentDidMount() {
    PricingActionCreator.preview();
    if (this.props.asynchronous_calendar && !this.isOpenToMultipleLocations()) {
      // Loading Syncronously when page is loaded
      TourAvailabilityActionCreator.getAvailableDates(
        this.props.tour_id,
        (res) => {
          this.setState({
            available_datetimes: res.data.available_datetimes,
            availableDates: res.data.available_dates,
            tourDates: res.data.available_dates,
          });
        }
      );
    }

    IntegrationActionCreator.queryOriginUrl();
  },

  _isMobile() {
    return (
      window.mobileDetect !== undefined && window.mobileDetect.phone() !== null
    );
  },

  componentDidUpdate(prevProps, prevState) {
    const {
      tour_name,
      total,
      total_without_service_fee,
      unit_price_for_initial_pricing,
      currency,
      saved,
      errors,
      booking_request_id,
      tourDates,
    } = this.state;
    const {
      tour_id,
      is_ga4_enabled,
      i18n,
      book_in_plugin,
      is_affiliate,
      segment_tracking_enabled: segmentTrackingEnabled,
      contact_props,
    } = this.props;
    const errorObject = errors.toJS();
    if (tour_name && !notificationSent) {
      notificationSent = true;
      try {
        googleTagManagerTourDetails({
          tour_name: tour_name,
          tour_id: tour_id,
          total_price: total,
          total_without_service_fee: total_without_service_fee,
          unit_price_for_initial_pricing: unit_price_for_initial_pricing,
          currency: currency.toUpperCase(),
          is_ga4_enabled: is_ga4_enabled,
        });
      } catch (error) {
        console.log('google tag error', error);
      }
    }

    if (tour_name && segmentTrackingEnabled && !trackedTours.has(tour_id)) {
      trackedTours.add(tour_id);
      try {
        const isMobile = this._isMobile();

        sendEventToSegment('Experience Details', {
          path: window.location.hash || window.location.pathname,
          referrer: document.referrer,
          session_id: getSessionId(),
          page_name: 'Experience Details',
          url: window.location.href,
          experience_id: tour_id,
          experience_name: tour_name,
          account_id: contact_props?.guide_id,
          account_name: contact_props?.guide_name,
          device: isMobile ? 'mobile' : 'web',
        });
      } catch (error) {
        console.log('segment tracking error', error);
      }
    }

    if (saved === true && prevState.saved === false) {
      const { plugin_slug: pluginSlug } = this.props;
      const pluginParam = pluginSlug ? `&plugin=${pluginSlug}` : '';
      const redirectUrl = `/booking_request/checkout?id=${booking_request_id}&lang=${i18n}${pluginParam}`;

      if (!is_affiliate && (this._isMobile() || !book_in_plugin)) {
        // insert port if iframe local dev
        IntegrationActionCreator.redirect_to(redirectUrl);
      } else {
        // Stay in plugin
        IntegrationActionCreator.scrollToSelector('body');
        const navTo =
          redirectUrl +
          this._getCuratedToursListParam() +
          this._getPluginParam();
        window.location = navTo;
      }
    }

    // This page relies on displaying errors in the form of a global modal
    // in the case of ticket capacity errors, we want to show them under the
    // ticket selection dropdown
    if (!_.isEmpty(errorObject)) {
      // Don't process capacity errors if user has already cleared them by changing selection
      const { capacityErrorCleared } = this.state;
      if (!capacityErrorCleared) {
        if (errorObject.hasOwnProperty('ticket-capacity'))
          this.setState({
            capacityError: errorObject['ticket-capacity'],
          });
        if (errorObject.hasOwnProperty('ticket-capacity-job-in-progress'))
          this.setState({
            capacityErrorJobInProgress:
              errorObject['ticket-capacity-job-in-progress'],
          });
      }
    }

    // Special situation. We don't have lingering error
    // messages in this form. We have visual feedback
    // only
    if (!_.isEmpty(errorObject)) {
      this.setState({
        errors: Immutable.Map({}),
      });
    }

    // Just finished saving
    if (
      prevState.loading === true &&
      saved === true &&
      prevState.saved === false
    ) {
      // Because spinner goes away before the page reloads
      this.setState({ loading: true });
    }

    // Loaded more tourDates
    if (!_.isEqual(tourDates, prevState.tourDates)) {
      this._availabilityChanged();
    }
  },

  _getDate() {
    let date = this.state.fields.get('date');

    let availableDatesToJs = {};
    if (Immutable.Map.isMap(this.state.availableDates)) {
      availableDatesToJs = this.state.availableDates.toJS();
    } else {
      availableDatesToJs = { ...this.state.availableDates };
    }

    if (
      this.state.availabilityFiltered &&
      date &&
      availableDatesToJs[date] === undefined
    ) {
      date = null;
    }

    return date;
  },

  _getTime() {
    let time = this.state.fields.get('time');

    if (this._getDate() === null) {
      time = null;
    }
    return time;
  },

  _getCuratedToursListParam() {
    // Returns name of CTL if plugin is in that context
    const currentUrlParsed = window.location.href.split('/');
    const indexOfCtl = currentUrlParsed.indexOf('curated-list');
    const ctlParam =
      indexOfCtl !== -1 ? `&ctl_name=${currentUrlParsed[indexOfCtl + 1]}` : '';
    return ctlParam;
  },

  _getPluginParam() {
    // Returns slug of Plugin if in that context
    const currentUrlParsed = window.location.href.split('/');
    const indexOfPlugin = currentUrlParsed.indexOf('plugin');

    if (indexOfPlugin !== -1) {
      return `&plugin=${currentUrlParsed[indexOfPlugin + 1]}`;
    }

    return '';
  },

  componentWillUnmount() {
    ModalActionCreator.hide();
  },

  onFieldChanged: {
    units: '_handleUnitsChange',
    guests: '_handleGuestsChanged',
    date: '_handleDateChanged',
    time: '_handleTimeChanged',
    addons: '_handleAddonsChanged',
  },

  _handleUnitsChange(newUnits) {
    const { has_ticket_capacity_enabled: hasTicketCapacityEnabled } =
      this.props;
    const { capacityError } = this.state;
    const guests = newUnits.reduce((t, u) => t + u.count, 0);
    this.setState({
      numOfAdults: countAdultsIn(newUnits, this.props.unit_types.items),
    });
    this.setState({ numOfGuests: guests });
    this.onChange('guests', guests);

    if (hasTicketCapacityEnabled) {
      if (capacityError) {
        this._clearCapacityData();
        this._refreshSlotCapacities();
      }
    }
  },

  _refreshSlotCapacities() {
    const { tour_public_id: tourPublicId } = this.props;

    if (this._getDate() && this._getTime()) {
      this._fetchSlotCapacities(tourPublicId, this._getDate(), this._getTime());
    }
  },

  _handleGuestsChanged(newValue) {
    // When guests change we need to affect all current addons
    const addons = _.clone(this.state.fields.get('addons'));
    const unitTypes = {};
    this.props.addons.forEach(
      (addon) => (unitTypes[addon.id] = addon.unit_type)
    );

    const newAddons = _.map(addons, (addon) => {
      if (unitTypes[addon.id] == 'person') {
        addon.count = Math.min(addon.count, newValue);
      }
      return addon;
    });

    this.setState({
      fields: this.state.fields.set('addons', newAddons),
    });
    this._bookingRequestChanged();
    if (!this._tooManyGuests()) {
      this._availabilityChanged();
    }
  },

  _handleDateChanged(newValue) {
    const { has_ticket_capacity_enabled: hasTicketCapacityEnabled } =
      this.props;

    // When the date changes we might need to deselect the time
    // if it's not available
    const date = this.state.availableDates[this._getDate()];
    const time = this._getTime();

    const guests = this.state.fields.get('guests');
    if (
      this.state.availabilityFiltered &&
      (!_.has(date, time) || date[time] < guests)
    ) {
      this.setState({
        fields: this.state.fields.set('time', null),
      });
    }
    this._availabilityChanged();
    const { capacityError } = this.state;
    if (hasTicketCapacityEnabled && capacityError) {
      this._clearCapacityData();
      this._refreshSlotCapacities();
    }
  },

  _clearCapacityData() {
    // Clear slot capacity data when new date is selected
    this.setState({
      capacityError: null,
      slotTicketCapacities: [],
      capacityErrorCleared: true,
    });
  },

  _handleTimeChanged(newTime) {
    this._bookingRequestChanged();

    const {
      has_ticket_capacity_enabled: hasTicketCapacityEnabled,
      tour_public_id: tourPublicId,
    } = this.props;
    const date = this._getDate();
    const time = newTime;

    if (hasTicketCapacityEnabled) {
      this._clearCapacityData();
      this._refreshSlotCapacities();
    }
  },

  _handleAddonsChanged(newAddons) {
    this._bookingRequestChanged();
  },

  _bookingRequestChanged() {
    BookingRequestActionCreator.change(this.state.fields.toJS());
  },

  _availabilityChanged() {
    TourAvailabilityActionCreator.filterDates(
      this.state.fields.get('guests'),
      this._getDate()
    );
  },

  validationConstraints() {
    return TimingValidations;
  },

  _additionalSubmitParams() {
    const { originUrl } = this.state;
    const { tour_id, booking_request_id } = this.props;

    const customerFacingURL =
      window.integrationScriptData?.parentLocation?.href;
    const localURL = originUrl || window.location.href;
    return {
      id: booking_request_id,
      tour_id,
      origin_url: localURL,
      customer_facing_experience_url: customerFacingURL || localURL,
    };
  },

  _dynamicCheckoutSlug() {
    const dynamicComponent =
      this.props.tour_settings.dynamic_checkout_component;
    if (!!dynamicComponent && !!dynamicComponent.value) {
      const DynamicCheckoutSlug = dynamic_components[dynamicComponent.value];
      return !!DynamicCheckoutSlug && this.state.total > 1 ? (
        <DynamicCheckoutSlug
          numOfAdults={this.state.numOfAdults}
          total={parseFloat(this.state.total)}
        />
      ) : null;
    }
    return null;
  },

  formSubmitted(params) {
    const {
      has_ticket_capacity_enabled: hasTicketCapacityEnabled,
      tour_public_id: tourPublicId,
    } = this.props;

    this.setState({ capacityErrorCleared: false });

    if (hasTicketCapacityEnabled && this._getDate() && this._getTime()) {
      this._fetchSlotCapacities(tourPublicId, this._getDate(), this._getTime());
    }

    if (this.props.can_be_paid_in_cash) {
      ModalActionCreator.show({
        content: this._paymentMethodsComponent(params),
        settings: { closable: true },
        showButton: false,
        showIcon: false,
      });
    } else {
      BookingRequestActionCreator.save(params);
    }
  },

  _doHideSingularTimes() {
    return (
      this.state.hide_inputs_if_no_choice_required &&
      this.state.availableTimes.size <= 1
    );
  },

  _shouldHideTimes() {
    return (
      this._doHideSingularTimes() || this.noLocation() || this._tooManyGuests()
    );
  },

  _shouldRenderCalendar() {
    const { is_enabled: isEnabled } = this.props;

    return (
      isEnabled &&
      !(
        Object.keys(this.state.availableDates).length == 1 &&
        this.state.hide_inputs_if_no_choice_required
      ) &&
      !this.noLocation()
    );
  },

  _shouldHideGuestDropdown() {
    return (
      !!this.state.hide_inputs_if_no_choice_required &&
      this.props.max_people == 1
    );
  },

  _shouldRenderAddons() {
    return (
      !this._noAvailableDates() &&
      !this._tooManyGuests() &&
      this.props.addons.length > 0 &&
      !!this._getTime()
    );
  },

  _shouldRenderForLayout() {
    return BookingDetailsStore.layoutNeeded() === this.props.layout;
  },

  _shouldRenderError() {
    return (
      (this.isOpenToMultipleLocations()
        ? this.state.location &&
          !this.state.isLoadingAvailableDates &&
          this._noAvailableDates()
        : this._shouldRenderCalendar() &&
          !this._noTourDates() &&
          this._noAvailableDates() &&
          this._anyDatesWithAvailability() &&
          this.state.isLoadingAvailableDates === false) &&
      !this._tooManyGuests()
    );
  },

  _datesDisabled() {
    return (
      (this.isOpenToMultipleLocations()
        ? !this.state.location ||
          this.state.isLoadingAvailableDates ||
          this._noAvailableDates()
        : this._noAvailableDates() || this._noTourDates()) ||
      this._tooManyGuests()
    );
  },

  _noAvailableDates() {
    let availableDatesToJs = {};

    if (Immutable.Map.isMap(this.state.availableDates)) {
      availableDatesToJs = this.state.availableDates.toJS();
    } else {
      availableDatesToJs = { ...this.state.availableDates };
    }

    return !Object.keys(availableDatesToJs).length;
  },

  _tooManyGuests() {
    const totalCount = this.state.fields.get('guests');
    const { min_people, max_people } = this.props;

    return totalCount < min_people || totalCount > max_people;
  },

  // Returns true if there is atleast one date with atleast 1 open slot
  _anyDatesWithAvailability() {
    let anyDatesAvailable = false;
    let dates = {};
    let availableDatesToJs = {};

    if (Immutable.Map.isMap(this.state.availableDates)) {
      availableDatesToJs = this.state.availableDates.toJS();
    } else {
      availableDatesToJs = { ...this.state.availableDates };
    }

    if (this.props.asynchronous_calendar && !this.isOpenToMultipleLocations()) {
      dates =
        Object.keys(availableDatesToJs).length > 0
          ? { ...availableDatesToJs }
          : this.state.tourDates;
    } else {
      dates =
        Object.keys(availableDatesToJs).length > 0
          ? { ...availableDatesToJs }
          : this.state.tourDates;
    }

    dates = Immutable.Map.isMap(dates) ? dates.toJS() : dates;

    Object.entries(dates).forEach(([date, slot]) => {
      if (Object.values(slot).some((s) => s > 0)) {
        anyDatesAvailable = true;
      }
    });

    return anyDatesAvailable;
  },

  _fetchSlotCapacities(tourPublicId, date, time) {
    TourAvailabilityService.getSlotTicketCapacities(tourPublicId, date, time)
      .then((response) => {
        const data = response.data;
        if (data.slotTicketCapacities) {
          const now = new Date();
          this.setState(
            {
              slotTicketCapacities: data.slotTicketCapacities,
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      })
      .catch((error) => {
        console.error('Error fetching slot capacities:', error);
      });
  },

  _noTourDates() {
    const { tourDates } = this.state;
    return !tourDates || !Object.keys(tourDates).length;
  },

  _dateProps() {
    const datePickerType = this.isOpenToMultipleLocations()
      ? 'calendar'
      : this.props.date_picker_type;

    let availableDatesToJs = {};
    if (Immutable.Map.isMap(this.state.availableDates)) {
      availableDatesToJs = this.state.availableDates.toJS();
    } else {
      availableDatesToJs = { ...this.state.availableDates };
    }

    return {
      multiple_locations: this.isOpenToMultipleLocations(),
      tourId: this.props.tour_id,
      availableDates: availableDatesToJs,
      availableSingleDay: this.props.available_single_date,
      initialDatesCount: Object.keys(this.state.tourDates).length,
      isLoadingAvailableDates: this.state.isLoadingAvailableDates,
      graySingleDate: !this._anyDatesWithAvailability(),
      datepickerType: datePickerType,
      showDates: this.state.showDates,
      disabled: this._datesDisabled(),
      onMount: this._handleDateChanged,
      weekStartDay: this.props.week_start_day,
      online: this.props.online,
      tourTimezone: this.props.tour_timezone,
      hasTicketCapacityEnabled: this.props.has_ticket_capacity_enabled,
    };
  },

  _timesProps() {
    let times = {};
    let available_dates = {};

    if (this.props.asynchronous_calendar && !this.isOpenToMultipleLocations()) {
      if (this._getDate()) {
        if (Immutable.Map.isMap(this.state.availableDates)) {
          available_dates = this.state.availableDates.toJS();
        } else {
          available_dates = { ...this.state.availableDates };
        }

        times = available_dates[this._getDate()];
      }
    } else {
      times = this.state.availableTimes.toJS();
    }

    return {
      times,
      datesAvailable: !this._noAvailableDates(),
      dateSelected: !!this._getDate(),
      guests: this.state.fields.get('guests'),
      displaySingleTime: !this._doHideSingularTimes(),
      isoTime: this.props.iso_time,
      online: this.props.online,
      tourTimezone: this.props.tour_timezone,
      hasTicketCapacityEnabled: this.props.has_ticket_capacity_enabled,
    };
  },

  _addonsProps() {
    const pricingAddons = this.state.addonPrices.size
      ? this.state.addonPrices.get('items').toJS()
      : [];
    return {
      availableAddons: addonsWithPrices(this.props.addons, pricingAddons),
      addonAvailability: this.props.addon_availability,
      date: this._getDate(),
      time: this._getTime(),
      guests: Math.min(this.state.fields.get('guests'), this.props.max_people),
      tourTimezone: this.props.tour_timezone,
    };
  },

  _guestsProps() {
    // XXX Needs to be handled better
    let unitPrices;
    const { is_enabled: isEnabled } = this.props;
    if (!!this.state.unitPrices && !!this.state.unitPrices.toJS) {
      unitPrices = this.state.unitPrices.toJS();
    } else {
      unitPrices = {};
    }
    return {
      unitPrices,
      unitTypes: this.props.unit_types,
      minPeople: this.props.min_people,
      maxPeople: this.props.max_people,
      initialTicketQuantity: this.props.initial_ticket_quantity,
      hasTicketCapacityEnabled: this.props.has_ticket_capacity_enabled,
      slotTicketCapacities: this.state.slotTicketCapacities || [],
      disabled:
        !isEnabled || this._noTourDates() || !this._anyDatesWithAvailability(),
      online: this.props.online,
      is_affiliate: this.props.is_affiliate,
      timeSelected: !!this._getTime(),
      tourTicketCapacities: this.props.ticket_capacities_details,
    };
  },

  _submitButtonProps() {
    const { loading, isLoadingAvailableDates } = this.state;
    const { tour_settings, can_be_paid_in_cash, intl } = this.props;
    const { request_booking_label } = tour_settings;
    const label = request_booking_label?.value;
    // The default label is 'Request Booking', but user can customize it with translations in Admin
    const translatedLabel =
      label === 'Request Booking'
        ? intl.formatMessage({
            defaultMessage: 'Request Booking',
            description:
              'Button label to request a booking for a tour or experience',
          })
        : label ||
          intl.formatMessage({
            defaultMessage: 'Continue to Checkout',
            description: 'Button label to proceed to the checkout process',
          });

    return {
      loading: loading,
      onClick: this.onSubmit,
      disabled:
        this._noAvailableDates() ||
        isLoadingAvailableDates ||
        this.noLocation(),
      supportsMultiplePaymentMethods: can_be_paid_in_cash,
      label: translatedLabel,
    };
  },

  _paymentMethodsComponent(bookingRequestParams) {
    return (
      <PaymentMethods
        bookingRequest={bookingRequestParams}
        loading={this.state.loading}
        cashTotal={this.state.cashTotal}
        onlineTotal={this.state.onlineTotal}
      />
    );
  },

  _errorProps() {
    const { intl } = this.props;
    let message = intl.formatMessage({
      defaultMessage: 'Sorry, no dates or times available',
      description:
        'Error message displayed when there are no available booking dates or times',
    });
    if (this.state.fields.get('guests') > 1) {
      message += ` ${intl.formatMessage({
        defaultMessage: 'for',
        description:
          'Preposition used in error message to indicate number of guests, e.g. "no dates available for 5 guests"',
      })} ${this.state.fields.get('guests')} ${this._getTicketCategoryName()}`;
    }
    message += '.';
    return {
      message,
    };
  },

  _getTicketCategoryName() {
    if (this.state.fields.get('guests') === 1) {
      return this.props.unit_types.root.noun_singular;
    }
    return this.props.unit_types.root.noun_plural;
  },

  // checks if this is an enabled + all location experience (birthday party, etc.)
  isOpenToMultipleLocations() {
    return this.props.multiple_locations && this.props.is_enabled;
  },

  setLocation(location) {
    const locationId = location.value.id;
    this.onChange('location_id', locationId);
    this.setState({ location });

    TourAvailabilityActionCreator.loadAPIDates(
      this.props.tour_id,
      locationId,
      () => {
        this.setState({
          fields: this.state.fields.set('date', null).set('time', null),
        });
      }
    );
  },

  setGuestTimezone({ timezone }) {
    this.setState({
      fields: this.state.fields.set('time_zone', timezone),
    });
  },

  setDateTime({ date, time }) {
    this.setState({
      fields: this.state.fields.set('date', date).set('time', time),
    });
  },

  clearTime() {
    this.setState({
      fields: this.state.fields.set('time', null),
    });
  },

  renderLocationSelect() {
    const { intl } = this.props;
    return (
      <div className="field" data-testid="store-dropdown">
        <label>
          {titleize(
            intl.formatMessage({
              defaultMessage: 'Store',
              description: 'Label for the store/location selection dropdown',
            })
          )}
        </label>
        <LocationSelect
          value={this.state.location}
          setValue={this.setLocation}
          userId={this.props.contact_props.guide_id}
          tourId={this.props.tour_id}
          pluginSlug={this.props.plugin_slug}
        />
      </div>
    );
  },

  _renderNoAvailability() {
    const { is_enabled: isEnabled } = this.props;
    return (
      !isEnabled ||
      ((this._noTourDates() || !this._anyDatesWithAvailability()) &&
        !this.isOpenToMultipleLocations())
    );
  },

  noLocation() {
    return this.isOpenToMultipleLocations() && !this.state.location;
  },

  shouldRenderLocation() {
    return this.isOpenToMultipleLocations();
  },

  _getAvailableTimes() {
    if (this.props.asynchronous_calendar && !this.isOpenToMultipleLocations()) {
      return [...this.state.available_datetimes];
    }
    return [...this.props.available_datetimes];
  },

  _shouldRenderTimeZoneWrapper() {
    if (this.props.asynchronous_calendar && !this.isOpenToMultipleLocations()) {
      if (this.state.available_datetimes.length) return true;
      return false;
    }

    // It's synchronous. Let it go
    return true;
  },

  renderCalendar() {
    if (this._shouldRenderTimeZoneWrapper()) {
      return (
        <TimezoneWrapper
          tourTimezone={this.props.tour_timezone}
          enabled={this.props.online}
          availableDatetimes={this._getAvailableTimes()}
          dateValue={this._formProps('date').value}
          timeValue={this._formProps('time').value}
          setDateTime={this.setDateTime}
          clearTime={this.clearTime}
          setGuestTimezone={this.setGuestTimezone}
        >
          {this._shouldRenderCalendar() && (
            <Dates
              location={this.state.location}
              {...this._formProps('date', this._dateProps())}
            />
          )}

          {this._shouldHideTimes() ? null : (
            <Times {...this._formProps('time', this._timesProps())} />
          )}
        </TimezoneWrapper>
      );
    }

    return <></>;
  },

  renderBookingDetails() {
    const {
      contact_props,
      tour_id,
      waitlist_details,
      sold_out_link_text,
      brand_color: brandColor,
      iso_time: isoTime,
    } = this.props;
    const { capacityError, capacityErrorJobInProgress } = this.state;
    const { has_available_waitlist_slots, enabled_for_tour, enabled_for_user } =
      waitlist_details || {};

    const classNames = classnames({
      'TourPage-BookingDetails': true,
      hidden: this.state.hidden,
      'padding-bottom': this.isOpenToMultipleLocations(),
    });
    const showWaitlistContent =
      has_available_waitlist_slots && enabled_for_tour && enabled_for_user;

    return (
      <div className={classNames}>
        <div
          data-testid="booking-request"
          className="BookingRequest-form ui form"
        >
          {this.shouldRenderLocation() && this.renderLocationSelect()}
          {this._shouldHideGuestDropdown() ? null : (
            <Guests
              {...this._formProps('units', this._guestsProps())}
              capacityError={capacityError}
              capacityErrorJobInProgress={capacityErrorJobInProgress}
            />
          )}

          {this.renderCalendar()}

          {this._shouldRenderAddons() && (
            <Addons {...this._formProps('addons', this._addonsProps())} />
          )}
          {this._shouldRenderError() && <Error {...this._errorProps()} />}

          {this._dynamicCheckoutSlug()}

          <SubmitButton {...this._submitButtonProps()} />

          {showWaitlistContent && (
            <JoinWaitlist
              experienceId={tour_id}
              noAvailability={this._renderNoAvailability()}
              userId={contact_props.guide_id}
              soldOutLinkText={sold_out_link_text}
              brandColor={brandColor}
              isoTime={isoTime}
            />
          )}

          {!showWaitlistContent && this._renderNoAvailability() && (
            <NoAvailability {...this.props.contact_props} />
          )}
        </div>
      </div>
    );
  },

  render() {
    if (this._shouldRenderForLayout()) {
      return this.renderBookingDetails();
    }
    return null;
  },
});

const BookingDetailsContext = (props) => {
  const contextValue = {
    segment_tracking_enabled: props.segment_tracking_enabled,
  };

  return (
    <SegmentTrackingProvider value={contextValue}>
      <BookingDetailsInternal {...props} />
    </SegmentTrackingProvider>
  );
};
export const BookingDetails = injectIntl(BookingDetailsContext);
